import { GeneralApiProblem } from './api';

export interface Organization {
  id: number;
  name: string;
  facilityIds: number[];
  createdAt: string;
  updatedAt: string;
}

export enum NewOrExisting {
  NEW = 'new_organization',
  EXISTING = 'existing_organization',
}

export interface ExistingDigitalOrderOrganization {
  organizationId?: number;
  newOrExistingOrganization: NewOrExisting;
  keyAccount?: boolean;
}

export interface NewDigitalOrderOrganization {
  organizationId?: number;
  name: string;
  isActive: string;
  newOrExistingOrganization: NewOrExisting;
}

export type DigitalOrderOrganization =
  | NewDigitalOrderOrganization
  | ExistingDigitalOrderOrganization;

export type GetAllOrganizationsResult = { kind: 'ok'; data: Organization[] } | GeneralApiProblem;
